
(function () {
  var CLAMP_LINES = 3;

  function prune(root) {
    var wraps = (root || document).querySelectorAll('[data-pdp-description]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var body = wrap.querySelector('.pdp-desc__body');
      if (!body) return;
      var lh = parseFloat(getComputedStyle(body).lineHeight) || 20;
      // scrollHeight is the full content height even while clamped.
      if (body.scrollHeight <= lh * CLAMP_LINES + 2) {
        wrap.classList.add('pdp-desc--fits');
      }
    });
  }

  /* ----------------------------------------------------------------
     Mobile image arrows

     The main image is a Flickity slider built by the Impulse bundle
     (theme.js:7683) with prevNextButtons off. Rather than change those
     arguments in a vendor file, these buttons look the instance up at
     click time via Flickity.data(). Resolving late matters: the slider
     is created after this script runs, and it is destroyed and rebuilt
     whenever an image set variant changes, so a reference captured at
     load would go stale.
     ---------------------------------------------------------------- */
  function slider(btn) {
    var id = btn.getAttribute('data-pdp-photo-target');
    var el = id && document.getElementById(id);
    if (!el || !window.Flickity || typeof window.Flickity.data !== 'function') return null;
    return window.Flickity.data(el) || null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pdp-photo-arrow]');
    if (!btn) return;

    var flkty = slider(btn);
    if (!flkty) return;

    e.preventDefault();
    if (btn.getAttribute('data-pdp-photo-arrow') === 'prev') {
      flkty.previous();
    } else {
      flkty.next();
    }
  });

  // Hide the arrows if the slider never initialised, so they are never
  // visible controls that do nothing.
  function checkArrows(root) {
    var btns = (root || document).querySelectorAll('[data-pdp-photo-arrow]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.hidden = !slider(btn);
    });
  }

  /* The product column is a flex column (pdp-rhythm.css), so every child
     spends a gap whether or not it draws anything. App blocks that are
     installed but render nothing on this product still measure zero high
     while holding a wrapper element, so :empty does not catch them and
     they leave a double gap in the middle of the column. Height is not
     something CSS can select on, so collapse them here. */
  function collapseEmptyBlocks(root) {
    var wraps = (root || document).querySelectorAll('[data-product-blocks]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      Array.prototype.forEach.call(wrap.children, function (child) {
        // Never touch anything the theme is deliberately hiding and will
        // later reveal, such as the variant inventory data holders.
        if (child.hasAttribute('data-pdp-collapsed')) return;
        if (child.offsetHeight === 0 && child.offsetWidth === 0) {
          child.setAttribute('data-pdp-collapsed', '');
          child.style.display = 'none';
        }
      });
    });
  }

  function init(root) {
    prune(root);
    collapseEmptyBlocks(root);
    // Apps inject late; re-check once the column has settled.
    window.setTimeout(function () { collapseEmptyBlocks(root); }, 1200);
    // Flickity initialises after this script, so check on the next frame
    // as well as immediately.
    checkArrows(root);
    window.requestAnimationFrame(function () { checkArrows(root); });
    window.setTimeout(function () { checkArrows(root); }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor re-renders the section; re-scan the replaced markup.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
